/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Use `import FabricAnalyticsListeners from '@atlaskit/analytics-listeners/FabricAnalyticsListeners'` instead.
 */
export { default } from './FabricAnalyticsListeners';

/**
 * @deprecated Use `import { LOG_LEVEL } from '@atlaskit/analytics-listeners/logger'` instead.
 */
export { LOG_LEVEL } from './helpers/logger';

/**
 * @deprecated Use `import { FabricChannel } from '@atlaskit/analytics-listeners/types'` instead.
 */
export { FabricChannel } from './types';
/**
 * @deprecated Use `import type { AnalyticsWebClient } from '@atlaskit/analytics-listeners/types'` instead.
 */
export type { AnalyticsWebClient } from './types';
